import type { PostDisbursementPayoutBatches422 } from 'api';

type Props = {
  error: PostDisbursementPayoutBatches422;
};

export const ErrorHandler = ({ error }: Props) => {
  return (
    error && (
      <div className="flex flex-col gap-3.5">
        <div>
          Format:<span className="ml-1 font-semibold">CSV</span>
        </div>
        <div>
          Name:
          <span className="ml-1 font-semibold">{error?.data?.filename}</span>
        </div>
        {error?.meta && (
          <>
            <div>
              Type:
              <span className="ml-1 font-semibold">
                {error.meta.local_instrument}
              </span>
            </div>
            <div>
              Corridor:
              <span className="ml-1 font-semibold">
                {error.meta.currency.iso} ({error.meta.currency.name}) -{' '}
                {error.meta.country.iso} ({error.meta.country.name})
              </span>
            </div>
          </>
        )}

        <div>
          {error.errors &&
            error.errors.map((error: { details: any }) =>
              error.details.map(
                (detail: boolean | null | undefined, index: number) => (
                  <div
                    key={index}
                    className="font-semibold italic text-feedback-error"
                  >
                    {detail}
                  </div>
                )
              )
            )}
        </div>

        <div className="pb-5">
          Please upload the batch with correct data, and try again.
        </div>
      </div>
    )
  );
};
